import React from 'react';
import { Switch, Route } from 'react-router-dom';
import OrganizationsList from 'views/Organizations/OrganizationsList';
import Details from 'views/Organizations/Details';

interface IIndexProps {
	match: {
		path: string;
	};
}

const Organizations = ({ match }: IIndexProps) => {
	return (
		<Switch>
			<Route path={match.path} exact render={(props: any) => <OrganizationsList {...props} />} />
			<Route
				path={`${match.path}/:accountId([0-9][0-9]*)/:subpage(account-details|departments)?`}
				render={(props: any) => <Details {...props} />}
			/>
		</Switch>
	);
};

export default Organizations;
